/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

exports.isWindowsWechat = function () {
    return (/windowswechat/i.test(navigator.userAgent)
    );
};

exports.isWechat = function () {
    return (/micromessenger/i.test(navigator.userAgent)
    );
};

exports.isMobile = function () {
    return (/(mobile|android|iphone|symbianos|ipad|ipod|windows phone)/i.test(navigator.userAgent)
    );
};

exports.isMobileWechat = function () {
    return exports.isWechat() && exports.isMobile();
};

exports.isQQ = function () {
    var str = navigator.userAgent;
    return (/sq/i.test(str) && /qq/i.test(str) && !exports.isWechat()
    );
};

exports.isDingding = function () {
    return (/dingtalk/i.test(navigator.userAgent)
    );
};



/*****************
 ** WEBPACK FOOTER
 ** ./application/helper/browser.js
 ** module id = 15
 ** module chunks = 1
 **/